import React from 'react';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';

import logoWithText from '../../images/skipify_horizontal_logo_white.svg';

interface WelcomeSidebarProps {
  isMobile?: boolean;
}

const WelcomeSidebar: React.FC<WelcomeSidebarProps> = ({ isMobile = false }) => {
  const theme = useTheme();
  const isActuallyMobile = useMediaQuery(theme.breakpoints.down('md'));
  const shouldShowMobile = isMobile || isActuallyMobile;

  return (
    <Box
      sx={{
        display: 'flex',
        background: 'black',
        flexDirection: 'column',
        width: { xs: '100%', md: '33%' },
        height: { xs: 'auto', md: '100vh' },
        alignItems: 'center',
        color: 'white',
      }}
    >
      <Box
        sx={{
          padding: { xs: '24px', md: '47px' },
          maxWidth: { xs: 'none', md: '400px' },
          width: '100%',
        }}
      >
        <img
          src={logoWithText}
          style={{
            maxWidth: '100px',
            height: '24px',
          }}
          alt="Skipify logo with text"
        />

        <Typography
          component="p"
          sx={{
            fontSize: { xs: '24px', md: '32px' },
            fontWeight: 600,
            lineHeight: '36px',
            letterSpacing: '-1px',
            color: 'white',
            marginTop: { xs: '32px', md: '109px' },
            marginBottom: '0px',
            paddingBottom: '10px',
          }}
        >
          Welcome to Skipify
        </Typography>

        <Typography
          component="p"
          sx={{
            color: '#b2b2b2',
            fontSize: { xs: '16px', md: '18px' },
            fontWeight: 400,
            lineHeight: '23px',
            margin: '0px',
          }}
        >
          Checkout is about to get a lot easier for your customers. This is your go to portal to
          customize their experience.
        </Typography>

        {!shouldShowMobile && (
          <>
            <Box sx={{ paddingTop: '50px' }}>
              <img
                src="https://cdn.skipify.com/skipify_horizontal_logo.svg"
                style={{
                  width: '60px',
                  height: '16px',
                }}
                alt="Skipify logo"
              />
              <Typography
                component="p"
                sx={{
                  color: 'white',
                  fontSize: '14px',
                  fontWeight: 400,
                  lineHeight: '20px',
                  margin: '0px',
                }}
              >
                <b>Configure.</b> Make adjustments to the payment gateway, order fulfillment,
                customer experience, co-branding and more.
              </Typography>
            </Box>

            <Box sx={{ paddingTop: '50px' }}>
              <img
                src="https://cdn.skipify.com/skipify_horizontal_logo.svg"
                style={{
                  width: '60px',
                  height: '16px',
                }}
                alt="Skipify logo"
              />
              <Typography
                component="p"
                sx={{
                  color: 'white',
                  fontSize: '14px',
                  fontWeight: 400,
                  lineHeight: '20px',
                  margin: '0px',
                }}
              >
                <b>Integrate.</b> Reference the SDK and API documentation as well as credentials.
              </Typography>
            </Box>

            <Box sx={{ paddingTop: '50px' }}>
              <Typography
                component="p"
                sx={{
                  color: '#01ead3',
                  fontSize: '11px',
                  fontWeight: 600,
                  lineHeight: '20px',
                  margin: '0px',
                }}
              >
                Coming Soon
              </Typography>
              <Typography
                component="p"
                sx={{
                  color: 'white',
                  fontSize: '14px',
                  fontWeight: 400,
                  lineHeight: '20px',
                  margin: '0px',
                }}
              >
                <b>Analyze.</b> Get detailed business intelligence reports on Skipify transactions.
              </Typography>
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
};

export default WelcomeSidebar;
